import PropTypes from 'prop-types';
import React from 'react';

import { Flex } from '../grid';
import { H4, P } from '../typography/new';

const BlockHeader = ({ heading, body, ...props }) => {
  if (!heading && !body) return null;

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      width="100%"
      alignItems="center"
      mb={{ xs: '36px', lg: '56px' }}
      {...props}
    >
      <Flex flexDirection="column" width={{ xs: '100%', md: 8 / 12 }} textAlign="center">
        <H4 my="0">{heading}</H4>
        {body && (
          <P mt={heading && '20px'} variant="standard">
            {body}
          </P>
        )}
      </Flex>
    </Flex>
  );
};

BlockHeader.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
};

BlockHeader.defaultProps = {
  body: null,
  heading: null,
};

export { BlockHeader };
